import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { CacheApi } from 'src/app/features/cache/cache-api';
import { CacheGroup } from 'src/app/features/cache/cache-table';
import { ApiResponse } from 'src/app/models/api';


export function mapPayload<T>(source: Observable<ApiResponse<T>>) {
  return source.pipe(map(res => res.payload));
}

